import {useEffect,useState} from 'react';
// Average colour of an avatar, darkened a little, used as the call tile background (like Discord).
const cache=new Map<string,string>();
export function useAvatarTint(src:string|null|undefined,fallback='#232329'):string{
 const [tint,setTint]=useState(()=>src&&cache.get(src)||fallback);
 useEffect(()=>{
  if(!src){setTint(fallback);return;}
  const hit=cache.get(src);if(hit){setTint(hit);return;}
  let alive=true;const img=new Image();img.crossOrigin='anonymous';
  img.onload=()=>{try{const c=document.createElement('canvas');c.width=c.height=16;const x=c.getContext('2d');if(!x)return;x.drawImage(img,0,0,16,16);const d=x.getImageData(0,0,16,16).data;let r=0,g=0,b=0,n=0;for(let i=0;i<d.length;i+=4){if(d[i+3]<128)continue;r+=d[i];g+=d[i+1];b+=d[i+2];n++;}if(!n)return;const k=0.82;const col=`rgb(${Math.round(r/n*k)},${Math.round(g/n*k)},${Math.round(b/n*k)})`;cache.set(src,col);if(alive)setTint(col);}catch{}};
  img.src=src;return()=>{alive=false;};
 },[src,fallback]);
 return tint;
}
